import { useEffect, useState } from 'react';
import { fetchMongoDBMonthlyCostData } from '../services/fetchMongoDBMonthlyCostData';
import { MongoDBMonthlyCostData} from '../constants/types';

export const useMongoDBMonthlyCostData = (token: string, year: number) => 
{
  const [initialData, setInitialData] = useState<MongoDBMonthlyCostData[]>([]);
  const [graphData, setGraphData] = useState<MongoDBMonthlyCostData[]>([]);
  const [hasConfirmed, setHasConfirmed] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
        const getData = async () => {
            const formattedData = await fetchMongoDBMonthlyCostData(token, year);
            if (formattedData) 
            {
                setInitialData(formattedData);
                setHasConfirmed(true);
            } 
            else {
                setInitialData([]);
            }
        };
        getData();
    }, []);

    useEffect(() => {
        const getData = async () => {
            const formattedData = await fetchMongoDBMonthlyCostData(token, year);
            if (formattedData) {
            setGraphData(formattedData);
            setHasConfirmed(true);
            } else {
            setGraphData([]);
            }
        };
        getData();
    }, [year]);

    return { initialData, graphData, hasConfirmed, error };
};